import React, { useEffect } from 'react'
import Box from '@material-ui/core/Box'
import WithdrawalFMSlipForm from '../../../components/admin/withdrawal/WithdrawalFMSlipForm'
import WithdrawalFMSlipTable from '../../../components/admin/withdrawal/WithdrawalFMSlipTable'
import useGDK from '../../../providers/admin/gdk/useGDK'
import { Branch } from '@golden/gdk-admin'

const WithdrawalFMSlipPage: React.FC = () => {
  const gdk = useGDK()
  useEffect(() => {
    gdk.trunk.trigger([Branch.PUBLISHERS, Branch.PLAYER_LAYER])
  }, [gdk])
  return (
    <Box paddingY={5}>
      <Box paddingX={5}>
        <WithdrawalFMSlipForm />
      </Box>
      <Box paddingTop={3}>
        <WithdrawalFMSlipTable />
      </Box>
    </Box>
  )
}

export default React.memo(WithdrawalFMSlipPage)
